<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>


<!-- Navigation -->
@if (layoutService.isScreenSmall()) {
<fuse-vertical-navigation class="bg-light print:hidden" [mode]="'over'" [name]="layoutService.isAdminPage() ? 'adminNavigation' :'mainNavigation'" [navigation]="layoutService.isAdminPage() ? navigationService.filteredNavigation().admin : navigationService.filteredNavigation().default" [opened]="false">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex min-h-20 items-center px-8 py-2">
      <app-logo></app-logo>
    </div>
  </ng-container>
</fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <app-impersonation-banner></app-impersonation-banner>

  <!-- Header -->
  <!-- Figma "Main nav": 64px bar, 1px bottom border instead of a shadow -->
  <div class="relative flex flex-0 items-center w-full h-16 dd-page-gutter z-49 border-b border-[#eeeff1] dark:border-[#2c2c2e] bg-card print:hidden">
    @if (!layoutService.isScreenSmall()) {
    <!-- Logo: fixed size (Figma: 40px tall), never squeezed by nav overflow -->
    <div class="flex shrink-0 items-center mx-2 lg:mr-8">
      <div class="hidden lg:flex shrink-0">
        <app-logo></app-logo>
      </div>
    </div>
    <!-- Horizontal navigation -->
    @if (!layoutService.isAdminPage()) {
    <fuse-horizontal-navigation class="w-full mr-2 default-navigation overflow-x-auto" data-cy="main-navigation" [name]="'mainNavigation'" [navigation]="navigationService.filteredNavigation()?.default">
    </fuse-horizontal-navigation>
    }
    @if (layoutService.isAdminPage()) {
    <fuse-horizontal-navigation class="mr-2 w-full" data-cy="admin-navigation" [name]="'adminNavigation'" [navigation]="navigationService.navigation()?.admin">
    </fuse-horizontal-navigation>
    }
    }
    <!-- Navigation toggle button -->
    @if (layoutService.isScreenSmall()) {
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')" data-cy='toggle-main-navigation'>
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    }

    <!-- icon menu (search, notifications, user) -->
    <!-- dd-drawer-inset-trailing: the nav BAR keeps its full width while an overlay drawer is open
         (the drawer runs over it, per fig frame 509119), but this trailing cluster would then sit
         underneath the panel — including the button that opens the quick-view panel in the first
         place. So the bar stays put and only this cluster steps inward. Rule in _widgets.scss. -->
    <app-icon-menu-items ddDrawerInset="trailing" class="flex pl-2 ml-auto space-x-0.5 sm:space-x-2"></app-icon-menu-items>
  </div>

  <!-- Content -->
  <!-- dd-drawer-inset-content: reserves room for an open widget overlay drawer so the panel sits
       BESIDE the page instead of on top of it (user decision 2026-08-25). Padding, not width, and
       driven entirely by the `dd-drawer-open` body class + `--dd-drawer-inset` — see _widgets.scss
       for the geometry, including the 1280px floor below which the inset is skipped. -->
  <div ddDrawerInset="content" class="flex flex-col flex-auto w-full">
    <router-outlet></router-outlet>
  </div>
</div>
